export const PROCEDURE_CAM_PRESENCE_STEP_ID: string = "__presence__";
